import { CLUB_COMPANY_OVERVIEW_ROUTER, CLUB_COMPANY_COMPANY_ROUTER } from "@Router/routerPath";
import { ClubOverviewPage, CompanyPage } from "@Local/ClubCompany";
import { FRONT_KEY } from "@Constants/frontKey";

const clubCompanyRouter = [
	{
		description: "加盟店管理",
		frontKey: FRONT_KEY.CLUB_COMPANY,
	},
	{
		description: "店舖總覽",
		frontKey: FRONT_KEY.CLUB_COMPANY_OVERVIEW,
		static: true,
		exact: true,
		path: CLUB_COMPANY_OVERVIEW_ROUTER,
		href: CLUB_COMPANY_OVERVIEW_ROUTER,
		as: ClubOverviewPage,
	},
	{
		description: "公司管理",
		frontKey: FRONT_KEY.CLUB_COMPANY_COMPANY,
		static: true,
		exact: true,
		path: CLUB_COMPANY_COMPANY_ROUTER,
		href: CLUB_COMPANY_COMPANY_ROUTER,
		as: CompanyPage,
	},
];

export default clubCompanyRouter;
